export function createRoutes() {
  return [
    {
      path: 'schedules-monthly',
      component: () => import(/* webpackChunkName: "ScheduleMonthlyChrome" */ './ScheduleMonthlyChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "ScheduleMonthlyList" */ './ScheduleMonthlyList.vue'),
        },
        {
          path: 'create',
          component: () => import(/* webpackChunkName: "ScheduleMonthlyNew" */ './ScheduleMonthlyNew.vue'),
        },
        {
          path: ':scheduleId',
          component: () => import(/* webpackChunkName: "ScheduleMonthlyEditChrome" */ './ScheduleMonthlyEditChrome.vue'),
          children: [
            {
              path: '/',
              component: () => import(/* webpackChunkName: "ScheduleMonthlyEdit" */ './ScheduleMonthlyEdit.vue'),
            },
          ],

        },
      ],
    },
  ];
}

export default {
  createRoutes,
};
